import { render, staticRenderFns } from "./AccessControlRolesOverview.vue?vue&type=template&id=34dc4781&"
import script from "./AccessControlRolesOverview.vue?vue&type=script&lang=js&"
export * from "./AccessControlRolesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports